import { useEffect } from 'react';
import initialize from './notifications';
import { useSessionStore } from '../../lib/Store/sessionStore.component';
export const useFirebaseNotifications = () => {
  const { setNotificationToken } = useSessionStore.getState();
  useEffect(() => {
    initialize();
  }, [setNotificationToken])
};
